













































































































import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";

import AutomaticReportJobDetailsTable from "@/components/Settings/AutomaticReportJobDetailsTable.vue";
import VIcon from "@/components/VIcon.vue";
import VModal from "@/components/VModal.vue";
import AutomaticReportJobMixin from "@/mixins/http/AutomaticReportJobMixin";
import { AutomaticReport, AutomaticReportJobCompetitor } from "@/models";
import {
  AutomaticReportJob,
  isCompetitorJob,
} from "@/models/AutomaticReports/AutomaticReportJob";
import { AutomaticReportJobStatus } from "@/models/AutomaticReports/AutomaticReportJob";
import { formatApiDate } from "@/services/ApiDateHelper";
import ToastInvoker, { responseErrorMessage } from "@/utils/ToastInvoker";

@Component({
  components: { AutomaticReportJobDetailsTable, VIcon, VModal },
})
export default class AutomaticReportJobsTable extends Mixins(
  AutomaticReportJobMixin
) {
  @Prop({ required: true }) readonly automaticReport!: AutomaticReport;
  @Prop({ required: true }) readonly profileSlug!: string;

  @Ref("snapshotModal") readonly snapshotModal!: VModal;

  automaticReportJobs: AutomaticReportJob[] = [];
  loading = false;
  error = false;
  page = 1;
  replayingAutomaticReportJobId: string | null = null;
  selectedAutomaticReportJob: AutomaticReportJobCompetitor | null = null;

  private fetching = false;

  get jobsTag(): string {
    return this.automaticReportJobsTag(this.automaticReport.id);
  }

  get status() {
    return this.requestStatus(this.jobsTag);
  }

  get currentPage(): number {
    return this.status?.meta?.currentPage ?? this.page;
  }

  get totalPages(): number {
    return this.status?.meta?.totalPages ?? 1;
  }

  get hasNextPage(): boolean {
    const links = this.status?.links;
    if (links) return links.next != null;
    return this.currentPage < this.totalPages;
  }

  @Watch("automaticReport.id", { immediate: true })
  onAutomaticReportChange() {
    this.page = 1;
    this.fetchAutomaticReportJobs();
  }

  goToPage(page: number) {
    if (page < 1 || this.loading) return;
    this.page = page;
    this.fetchAutomaticReportJobs();
  }

  async fetchAutomaticReportJobs() {
    if (!this.profileSlug) return;
    if (this.fetching) return;
    this.fetching = true;
    this.loading = true;
    this.error = false;
    try {
      this.automaticReportJobs = await this.indexAutomaticReportJobs(
        this.profileSlug,
        this.automaticReport.id,
        this.page,
        this.jobsTag
      );
    } catch (e) {
      this.error = true;
      this.automaticReportJobs = [];
    } finally {
      this.loading = false;
      this.fetching = false;
    }
  }

  rowClass(status: AutomaticReportJobStatus): string {
    return `jobs-row--${status}`;
  }

  messageLabel(automaticReportJob: AutomaticReportJob): string {
    return automaticReportJob.message || "-";
  }

  formatDate(value?: string): string {
    return formatApiDate(value, "DD/MM/YYYY HH:mm") || "-";
  }

  async onReplay(automaticReportJob: AutomaticReportJob) {
    if (automaticReportJob.status !== "error") return;
    this.replayingAutomaticReportJobId = automaticReportJob.id;
    try {
      await this.replayAutomaticReportJob(
        this.profileSlug,
        automaticReportJob.id
      );
      ToastInvoker.successToast("Job rieseguito.");
      await this.fetchAutomaticReportJobs();
    } catch (error) {
      ToastInvoker.errorToast(responseErrorMessage(error), error);
    } finally {
      this.replayingAutomaticReportJobId = null;
    }
  }

  get snapshotTitle(): string {
    if (!this.selectedAutomaticReportJob) return "Dettagli job";
    return `Dettagli job del ${this.formatDate(
      this.selectedAutomaticReportJob.createdAt
    )}`;
  }

  openSnapshot(automaticReportJob: AutomaticReportJob) {
    if (!isCompetitorJob(automaticReportJob)) return;
    this.selectedAutomaticReportJob = automaticReportJob;
    this.$nextTick(() => this.snapshotModal.show());
  }

  closeSnapshot() {
    this.snapshotModal.hide();
  }
}
